import React, { Component, useState, createContext, Fragment, useEffect } from "react";
import Icon from "./layout/icon";

import "../styles/error-modal.scss";

export const ErrorContext = createContext();

export function ErrorProvider({ children }) {
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorModalTitle, setErrorModalTitle] = useState("");
    const [errorModalMessage, setErrorModalMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);

    const toggleErrorModal = (title, message, isSuccess = false) => {
        setShowErrorModal(!showErrorModal);
        setErrorModalTitle(title);
        setErrorModalMessage(message);
        setIsSuccess(isSuccess);
    };

    return (
        <ErrorContext.Provider value={{ showErrorModal, toggleErrorModal, errorModalTitle, errorModalMessage, isSuccess }}>
            {children}
        </ErrorContext.Provider>
    );
}
export class ErrorModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scrollY:"0"
        }
    }

    closeModal(){
        clearInterval(this.animationInterval);
        if(this.props.toggleErrorModal) this.props.toggleErrorModal();
    }

    componentDidMount(){
        window.addEventListener("message", (event) => {
            const { data, type } = event.data;
            switch (type) {
                case "scroll":
                this.setState({
                    scrollY: data.scrollY
                });
                break;
            }
        });
    }

    componentDidUpdate(){
        clearInterval(this.animationInterval);
        this.animationInterval = setInterval(() => {
            this.closeModal();
        }, 4000);
    }

    componentWillUnmount(){
        clearInterval(this.animationInterval);
    }
    
    render(){
        const successClass = this.props.isSuccess ? "success" : "";

        return(
        <Fragment>
            {(this.props.showErrorModal && (this.props.errorModalMessage || this.props.errorModalTitle)) && 
                <div className={`error-modal ${successClass}`} style={{top:this.state.scrollY-100}}>
                    <div className={`error-modal-content ${successClass}`}>
                        <div className={`error-modal-icon-wrapper ${successClass}`}>
                            <Icon type={successClass ? "doneCircle" : "undoneCircle"} color="white" key="alert" style={{stroke: '#FFFFFF', width: '50px'}}/>
                        </div>
                        <div className={`error-modal-content-wrapper ${successClass}`}>
                            {this.props.errorModalTitle && <h4>
                                <strong>{this.props.errorModalTitle}</strong>
                            </h4>}
                            {this.props.errorModalMessage && 
                                <p>{this.props.errorModalMessage}</p>
                            }
                        </div>
                        <div className={`error-modal-close-wrapper ${successClass}`} onClick={()=>{this.closeModal()}}>
                            <Icon type="close" color="white" key="close" style={{stroke: '#FFFFFF', width: '15px'}} />
                        </div>
                    </div>
                    <div className={`progress-bar ${successClass}`}></div>
                </div>
            }
            {this.props.children}
        </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/rifa/components/errorModal.jsx